import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense, lazy } from 'react'
import { Home } from './pages/Home'

// Lazy load heavy pages for bundle optimization
const Gallery = lazy(() => import('./pages/Gallery').then(module => ({ default: module.Gallery })))
const AdminPhotos = lazy(() => import('./pages/AdminPhotos').then(module => ({ default: module.AdminPhotos })))
const Upload = lazy(() => import('./pages/Upload').then(module => ({ default: module.Upload })))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route 
            path="/upload" 
            element={
              <Suspense fallback={<LoadingFallback message="アップロード画面を読み込み中..." />}>
                <Upload />
              </Suspense>
            } 
          />
          <Route 
            path="/gallery" 
            element={
              <Suspense fallback={<LoadingFallback message="ギャラリーを読み込み中..." />}>
                <Gallery />
              </Suspense>
            } 
          />
          <Route 
            path="/admin/photos" 
            element={
              <Suspense fallback={<LoadingFallback message="管理画面を読み込み中..." />}>
                <AdminPhotos />
              </Suspense>
            } 
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

function LoadingFallback({ message }: { message: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pastel-pink/20 to-pastel-purple/20">
      <div className="fairy-card p-8 text-center">
        <div className="animate-spin h-8 w-8 border-2 border-pastel-purple border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  )
}

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pastel-pink/20 to-pastel-purple/20">
      <div className="fairy-card p-8 text-center">
        <h1 className="text-4xl font-dancing mb-4">404</h1>
        <p className="text-gray-600 mb-4">ページが見つかりません</p>
        <a href="/" className="text-pastel-purple hover:underline">
          トップページへ戻る
        </a>
      </div>
    </div>
  )
}

export default App